/*
 * Copyright (c) 2019 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import { DataTable } from '@scuf/datatable';
import { Icon, Grid, Loader, Input, Button, Select, Modal } from '@scuf/common';
import * as React from 'react';
import { util, NotificationHeaderModal } from '@keystone/common';
import {
  withSiteContext,
  withApplicationContext,
  withCustomerSiteContext,
} from '../../common/HOCs';
import AppModal from '../../partials/AppModal';
import timezoneOptions from '../../common/timezone';

class ViewSites extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        id: null,
        siteName: null,
        timeZone: null,
      },
      selectedRow: null,
      sites: null,
      loadingSettings: false,
      reloadInterval: null,
      reloadCheckInterval: null,
      open: false,
      openEdit: false,
      disableMultipleDelete: true,
    };
  }

  componentDidMount() {
    const { appContext } = this.props;
    appContext.registerReloadFunction(this.reloadTableComponent);
    this.initializeTable();
    appContext.setNotification(null);
  }

  reloadTableComponent = async (signal) => {
    const sites = await this.props.siteContext.fetchSites(signal);
    this.setState({ sites });
  };

  componentWillUnmount() {
    const { appContext } = this.props;
    appContext.unregisterReloadFunction();
  }

  initializeTable = async () => {
    this.setState({ loadingSettings: true });
    await this.props.siteContext.fetchSites();
    this.setState({
      sites: this.props.siteContext.sites,
    });
    this.setState({ loadingSettings: false });
  };

  onSiteNameChange = (siteName) => {
    this.setState({ form: { ...this.state.form, siteName } });
  };

  onTimeZoneChange = (timeZone) => {
    this.setState({ form: { ...this.state.form, timeZone } });
  };

  toggleMultipleDelete = (e) => {
    if (e.length > 1) {
      this.setState({ disableMultipleDelete: false });
    } else {
      this.setState({ disableMultipleDelete: true });
    }
  };

  disableMultipleDelete = () => {
    this.props.siteContext.toggleConfirmDeleteSitesModal();
    this.props.siteContext.clearSelectedSites();
    this.setState({ disableMultipleDelete: true });
  };

  handleMultipleDeleteButton = async () => {
    const { appContext, siteContext } = this.props;
    await this.props.siteContext.deleteSites();
    appContext.reload();
    this.setState({ disableMultipleDelete: true });
  };

  handleSingleDeleteModal = async (props) => {
    await this.props.siteContext.setSelectedSite(props);
    await this.props.siteContext.toggleConfirmSingleDeleteSiteModal();
  };

  openAddSiteModal = () => {
    const form = {
      siteName: null,
      timeZone: null,
    };
    this.setState({ form });
    this.props.appContext.notificationModal.hasNotification = false;
    this.props.appContext.notificationModal.notificationText = '';
    this.props.appContext.notificationModal.severity = '';
    this.setState({ open: true });
  };

  clearSelectionAfterCancelEdit = () => {
    const form = {
      id: null,
      siteName: null,
      timeZone: null,
    };
    this.setState({ openEdit: false });
    this.setState({ open: false });
    this.setState({ form });
    this.props.siteContext.clearSelectedSites();
    this.props.appContext.notificationModal.hasNotification = false;
    this.props.appContext.notificationModal.notificationText = '';
    this.props.appContext.notificationModal.severity = '';
  };

  onEditSite = (props) => {
    const form = props;
    this.setState({ form });
    this.props.appContext.notificationModal.hasNotification = false;
    this.props.appContext.notificationModal.notificationText = '';
    this.props.appContext.notificationModal.severity = '';
    this.setState({ openEdit: true });
  };

  userActionIcons = (props) => {
    let action = '';
    if (props.identifier !== -1) {
      action = (
        <div>
          <a onClick={() => this.onEditSite(props)}>
            <Icon name="edit" size="large" />
          </a>
          <a onClick={() => this.handleSingleDeleteModal(props)}>
            <Icon name="delete" size="large" />
          </a>
        </div>
      );
    } else {
      action = (
        <div>
          <a onClick={() => this.onEditSite(props)}>
            <Icon name="edit" size="large" />
          </a>
        </div>
      );
    }

    return action;
  };

  renderActionButtons = () => {
    const { appContext } = this.props;
    if (util.getSentienceEnableFlag || appContext.isAdmin) {
      return (
        <DataTable.HeaderBar>
          <DataTable.HeaderBar.Item
            content="Add"
            icon={<Icon name="slidercontrols-plus" size="small" root="common" />}
            onClick={() => this.openAddSiteModal()}
          />
          <DataTable.HeaderBar.Item content="" />
        </DataTable.HeaderBar>
      );
    }
    return <></>;
  };

  addSiteSumbit = async () => {
    const { appContext, siteContext } = this.props;
    const { form } = this.state;
    this.setState({ loadingSettings: true });
    const response = await siteContext.createSite(form);
    await appContext.reload();
    this.setState({ loadingSettings: false });
    if (!(response instanceof Error)) {
      this.setState({ open: false });
    }
  };

  editSiteSubmit = async () => {
    const { appContext, siteContext } = this.props;
    const { form } = this.state;
    this.setState({ loadingSettings: true });
    const response = await siteContext.editSite(form);
    await appContext.reload();
    this.setState({ loadingSettings: false });
    if (!(response instanceof Error)) {
      this.setState({ openEdit: false });
    }
  };

  render() {
    return (
      <div style={{ position: 'relative', height: '100%' }}>
        <Grid>
          <Grid.Row />
          <Grid.Row>
            <Grid.Column width={12}>
              <h3 />
              {this.renderModal()}
              {this.renderEditModal()}
              {this.renderDeleteModal()}
              {this.renderSingleDeleteModal()}
              <Loader
                loading={this.state.loadingSettings}
                overlayOpacity={0.2}
                overlayColor="#B2AFAF"
              >
                <div className="placeholder" />
              </Loader>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={12}>
              <DataTable
                data={
                  this.state.sites === null
                    ? []
                    : this.state.sites === undefined
                    ? []
                    : this.state.sites
                }
                resizableColumns
                columnResizeMode="fit"
                reorderableColumns={false}
                selection={this.props.siteContext.selectedRows}
                onSelectionChange={(e) => {
                  this.props.siteContext.setSelectedRows(e);
                  this.toggleMultipleDelete(e);
                }}
                metaKeySelection={false}
                scrollable
                search
              >
                {this.renderActionButtons()}
                {/*
                                To-Do: Uncomment this code when delete site functionality is implemented
                                DataTable.Column selectionMode="multiple" initialWidth={100} />
                            */}
                <DataTable.Column field="siteName" header="Site Name" sortable initialWidth="20%" />
                <DataTable.Column
                  field="timeZone"
                  header="Time Zone"
                  sortable
                  initialWidth="20%"
                  fluid
                  error={null}
                  indicator="required"
                  onChange={(data) => this.onTimeZoneChange(data)}
                />
                <DataTable.Column
                  field="identifier"
                  header="Actions"
                  sortable={false}
                  initialWidth="20%"
                  renderer={(props) => this.userActionIcons(props.rowData)}
                />
                <DataTable.Pagination
                  itemsPerPage={10}
                  totalItems={
                    this.state.sites === null
                      ? 1
                      : this.state.sites === undefined
                      ? 1
                      : this.state.sites.length
                  }
                  showDisplayDetails
                />
              </DataTable>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  renderModal() {
    return (
      <Modal
        onClose={() => this.setState({ open: false })}
        open={this.state.open}
        dimmer={this.state.hasDimmer}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
      >
        <Modal.Content>
          {this.props.appContext.notificationModal.hasNotification ? (
            <NotificationHeaderModal context={this.props.appContext} />
          ) : (
            <></>
          )}
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <h1>Create Site</h1>
                <Loader
                  loading={this.state.loadingSettings}
                  overlayOpacity={0.2}
                  overlayColor="#B2AFAF"
                >
                  <div className="placeholder" />
                </Loader>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="Site Name"
                  placeholder="Site Name"
                  maxLength="30"
                  indicator="required"
                  onChange={(data) => this.onSiteNameChange(data)}
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Select
                  label="Time Zone"
                  options={timezoneOptions}
                  placeholder="Select a TimeZone"
                  onChange={(value) => this.onTimeZoneChange(value)}
                  fluid="true"
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6} />
              <Grid.Column width={6} />
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="secondary"
            size="small"
            content="Cancel"
            onClick={() => {
              this.clearSelectionAfterCancelEdit();
            }}
          />
          <Button
            type="primary"
            size="small"
            content="Submit"
            onClick={() => {
              this.addSiteSumbit();
            }}
          />
        </Modal.Footer>
      </Modal>
    );
  }

  renderEditModal() {
    return (
      <Modal
        onClose={() => this.setState({ openEdit: false })}
        open={this.state.openEdit}
        dimmer={this.state.hasDimmer}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
      >
        <Modal.Content>
          {this.props.appContext.notificationModal.hasNotification ? (
            <NotificationHeaderModal context={this.props.appContext} />
          ) : (
            <></>
          )}
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <h1>Edit Site</h1>
                <Loader
                  loading={this.state.loadingSettings}
                  overlayOpacity={0.2}
                  overlayColor="#B2AFAF"
                >
                  <div className="placeholder" />
                </Loader>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="Site Name"
                  indicator="required"
                  value={this.state.form.siteName}
                  disabled="true"
                  onChange={(data) => this.onSiteNameChange(data)}
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Select
                  label="Time Zone"
                  options={timezoneOptions}
                  value={this.state.form.timeZone}
                  onChange={(value) => this.onTimeZoneChange(value)}
                  fluid="true"
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6} />
              <Grid.Column width={6} />
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="secondary"
            size="small"
            content="Cancel"
            onClick={() => {
              this.clearSelectionAfterCancelEdit();
            }}
          />
          <Button
            type="primary"
            content="Submit"
            size="small"
            onClick={() => {
              this.editSiteSubmit();
            }}
          />
        </Modal.Footer>
      </Modal>
    );
  }

  renderDeleteModal() {
    return (
      <AppModal
        isOpen={this.props.siteContext.isConfirmDeleteModalOpen}
        content="Would you like to delete the selected sites?"
        handleSubmit={() => this.handleMultipleDeleteButton()}
        handleToggle={() => this.disableMultipleDelete()}
      />
    );
  }

  renderSingleDeleteModal() {
    return (
      <AppModal
        isOpen={this.props.siteContext.isConfirmSingleDeleteModalOpen}
        content="Would you like to delete the selected site?"
        handleSubmit={async () => {
          await this.props.siteContext.deleteSite();
          this.props.appContext.reload();
        }}
        handleToggle={() => this.props.siteContext.toggleConfirmSingleDeleteSiteModal()}
      />
    );
  }
}

export default withApplicationContext(withCustomerSiteContext(withSiteContext(ViewSites)));
